import { Col, DatePicker, Form, Radio, Row } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React from "react";
import { useTranslation } from "react-i18next";
import { DateFormat, RECOVERY_STATUS } from "../../../../../constants/constants";
import { ControlFailureModel } from "../../../../../models/control-failure.model";
import { FormSectionProps } from "../../../../../models/form-section.model";
import { AMOUNT_UTIL } from "../../../../../utils/amount.utils";
import { VALIDATION_UTIL } from "../../../../../utils/validation.utils";
import AmountInput from "../../../../atoms/amount-input";
import { InfoCircleIcon } from "../../../../atoms/icon";

const RecoveryInformationSection = (props: FormSectionProps<ControlFailureModel>) => {

    const { t } = useTranslation();

    return (
        <div className="section-wrapper">
            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbRecoveryStatus")}
                        name="recovery_status"
                        tooltip={{ title: t("ControlFailure.ttRecoveryStatus"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("recovery_status", props.requiredFields)}
                    >
                        <Radio.Group>
                            {RECOVERY_STATUS.map((item, index) => (
                                <Radio key={index} value={item.value}>{item.name}</Radio>
                            ))}
                        </Radio.Group>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbInsuranceRecoveryAmount")}
                        name="insurance_recovery_amount"
                        tooltip={{ title: t("ControlFailure.ttInsuranceRecoveryAmount"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("insurance_recovery_amount", props.requiredFields)}
                    >
                        <AmountInput />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbInsuranceRecoveryDate")}
                        name="insurance_recovery_date_picker"
                        tooltip={{ title: t("ControlFailure.lbInsuranceRecoveryDate"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("insurance_recovery_date", props.requiredFields)}
                    >
                        <DatePicker format={DateFormat.view} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbOtherRecoveryAmount")}
                        name="other_recovery_amount"
                        tooltip={{ title: t("ControlFailure.ttOtherRecoveryAmount"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("other_recovery_amount", props.requiredFields)}
                    >
                        <AmountInput />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbOtherRecoveryDate")}
                        name="other_recovery_date_picker"
                        tooltip={{ title: t("ControlFailure.ttOtherRecoveryDate"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("other_recovery_date", props.requiredFields)}
                    >
                        <DatePicker format={DateFormat.view} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 24]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbRecoveryDescription")}
                        name="other_recovery_description"
                        rules={VALIDATION_UTIL.getRulesValidationField("other_recovery_description", props.requiredFields)}
                    >
                        <TextArea rows={5} maxLength={150} placeholder={t("Global.plTextArea")} />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item>
                <Row gutter={[10, 10]}>
                    <Col span={24} className="text-total">
                        <p>{t("ControlFailure.lbTotalRecovery")}</p><span>{AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.total_recovery)}</span>
                    </Col>
                    <Col span={24} className="text-total">
                        <p>{t("ControlFailure.lbNetLoss")}</p><span>{AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_loss)}</span>
                    </Col>
                </Row>
            </Form.Item>

        </div>
    )
}

export default RecoveryInformationSection;